// @ts-check
import { configStore } from './config.store';
/**
 * //FIXME: fix invalid index, possible solution is to keep track of the invalid indexes
 * Get bet items combination from generated combination indexes,
 * check if combination is valid
 * @param {number[]} comb - array of indexes for arr array
 * @param {string[]} arr - bet items array
 * @param {{[x:string]:boolean}} bankers - map of bankers
 * @returns 
 */
function getComb(comb, arr, bankers) {
	let validComb = true;
	const uniqueMid = {};
	let bankerFound = 0;
	let newComb = [];

	let invalidIndex = 0;
	for (let i = 0; i < comb.length; i++) {
		const c = arr[comb[i]];
		newComb.push(c);
		const mid = c.split('_')[0];
		if (uniqueMid[mid]) {
			validComb = false;
			// invalidIndex = i;
			break;
		}
		uniqueMid[mid] = true;
		if (bankers[c]) {
			bankerFound += 1;
		}
	}

	let nextValidIndex = 0;
	if (invalidIndex) {
		for (let i = comb[invalidIndex]; i < arr.length - 1; i++) {
			const mid = arr[i].split('_')[0];
			const newMid = arr[i + 1].split('_')[0];
			if (mid !== newMid) {
				nextValidIndex = i;
				break;
			}
		}
	}
	let validBankers = Object.keys(bankers).length === bankerFound;
	validComb = validComb && validBankers;
	return { comb: newComb, validComb, invalidIndex, nextValidIndex, validBankers };
}

/**
 * Lazy generate combinations of size r for bet items given in arr
 * Arr must have banker items at the front of the array and remove items with same matchId as banker since they
 * are invalid combinations
 * Arr must also be sorted by matchId
 * @param {string[]} arr - string array of bet item keys (matchId_marketId_outcomeId)
 * @param {number} r - size of combination
 * @param {{[x:string]:boolean}} b - map of bankers
 * @returns generator for next combination
 */
function* generate(arr, r, b) {
	const n = arr.length;
	let combination = [];
	const bankerLength = Object.keys(b).length;

	// initialize with lowest lexicographic combination
	for (let i = 0; i < r; i++) {
		combination[i] = i;
	}
	// If we have more bankers than r-subset length return
	if (bankerLength > r) {
		return;
	}

	while (combination[r - 1] < n) {
		let { comb, validComb, invalidIndex, nextValidIndex, validBankers } = getComb(combination, arr, b);
		if (validComb) {
			yield comb;
		}

		// If we have combs with same mid, get the next valid lowest lexicographic combination
		if (!validComb && invalidIndex && nextValidIndex) {
			// FIXME: remove debug code
			// if (r === 5 && combination[0] === 0) {
			// 	console.log("INDEXES:");
			// 	console.log(invalidIndex);
			// 	console.log(nextValidIndex);
			// }
			for (let i = invalidIndex; i < r; i++) {
				nextValidIndex += 1;
				combination[i] = nextValidIndex;
			}
			continue;
		}

		if (!validBankers) {
			if (combination[bankerLength - 1] !== bankerLength - 1) return;
		}

		// generate next combination in lexicographic order
		let t = r - 1;
		while (t != 0 && combination[t] == n - r + t) {
			t--;
		}
		combination[t]++;
		for (let i = t + 1; i < r; i++) {
			combination[i] = combination[i - 1] + 1;
		}
	}

}

/**
 * Order items by following order:  
 * put items with bankers at the beggining and other items after
 * clear same match if banker is selected and same match items are present
 * finally sort items by matchId
 * @param {{[x:string]:boolean}} bankers - bankers map
 * @param {string[]} items - bet items array
 */
function getOrderedItems(bankers, items) {
	const bKeys = Object.keys(bankers);
	const midBankers = bKeys.reduce((acc, c) => {
		acc[c.split('_')[0]] = true;
		return acc;
	}, {});
	// Filter all items that have same matchId as bankers
	// FEAT: maybe filter items with same mid and put them at end of array for better performance?
	const filteredItems = items.filter(i => {
		const iMid = i.split('_')[0];
		return !midBankers[iMid];
	}).sort((a, b) => Number(a.split('_')[0]) - Number(b.split('_')[0]));
	return bKeys.concat(filteredItems);
}

/**
 * Get all combinations with size k
 * @param {string[]} items - array of bet item keys
 * @param {number} k - combination size
 * @param {{[x:string]:boolean}} bankers - map of bankers
 * @returns 
 */
export function getCombsAtFold(items, k, bankers) {
	let maxLines = configStore.settings.MAX_LINES;
	const arr = getOrderedItems(bankers, items);
	let skip = 0;
	let combs = [];
	for (const c of generate(arr, k, bankers)) {
		if (skip > maxLines) return [];
		skip += 1;
		combs.push(c);
	}
	return combs;
}

/**
 * Calculate lines per fold
 * @param {string[]} items - array of bet item keys
 * @param {number} n - number of unique items
 * @param {{[x:string]:boolean}} bankers - map of bankers
 * @returns {Partial<{[x:number]:number}>} - fold and number of lines in fold
 */
export function calculateLines(items, n, bankers = {}) {
	let maxLines = configStore.settings.MAX_LINES;
	let lines = {};
	let arr = getOrderedItems(bankers, items);

	const len = items.length;
	const bankersLength = Object.keys(bankers).length;
	/**
	 * Flag if we can skip calucaltions for lines
	 * We can skip if we only have 1 outcome per match and no bankers
	 * since then the number of combination is symetrical and we can just get the value from previous calculated value
	 */
	const canSkip = (len === n) && (bankersLength === 0);
	const half = Math.floor(n / 2);
	const r = n % 2;

	for (let i = 1; i <= n; i++) {
		let skip = 0;
		if (i !== n && i > half) {
			lines[i] = lines[half - (i - half) + r];
			// if canSkip flaf is true or symetrical lines where more than max allowed lines skip line calculation
			if (canSkip || lines[i] > maxLines) {
				continue;
			}
		}
		// FEAT: test if this bring us better performance?
		// if we are below half and last line was above max line skip calculations as the next combo will be bigger than max lines
		// if (lines[i - 1] && i <= half && lines[i - 1] > maxLines) {
		// 	lines[i] = lines[i - 1];
		// 	continue;
		// }

		// eslint-disable-next-line
		for (const c of generate(arr, i, bankers)) {
			if (skip > maxLines) break;
			skip += 1;
		}
		lines[i] = skip;
	}
	return lines;
}
